export default {
  ReadAsMaster: function(action, self, onsuccess, onfailed) {
    return {
        data : {     
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action: action,
        onsuccess : onsuccess,
        onfailed : onfailed,
    }
  },
  Read: function(action, self, onsuccess, onfailed, filter, order, page) {
    return {
        data : {    
          filter: filter,
          order: order,
          page: page,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action: action,
        onsuccess : self.onReadSuccess,
        onfailed : self.onReadFailed,
    }
  },
  ReadByAsset: function(action, self, onsuccess, onfailed, page) {
    return {
        data : {
          page : page,
          query: self.props.asset.assetAlias,
          AuthorizationToken : self.props.UserReducer.token,
        },
        action: action,
        self : self,
        onsuccess : self.onReadSuccess,
        onfailed : self.onReadFailed,
    }
  },
  Register: function(self, onsuccess, onfailed) {
    return {
        data : {
          Asset          : self.state.asset,
          Service        : self.state.service,
          Description    : self.state.description,
          ScheduledStart : self.state.scheduledStart_UTC,
          ScheduledEnd   : self.state.scheduledEnd_UTC,
          RepeatPeriod   : self.state.repeatPeriod,
          RepeatType     : self.state.repeatType,
          IsReminder     : self.state.isReminder,
          IsRepeating    : self.state.isRepeating,
          NextScheduled  : self.state.nextScheduled_UTC,    
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onRegisterSuccess,
        onfailed : self.onRegisterFailed,
    }
  },
  RegisterRequestMaintenance(self, onsuccess, onfailed) {
    return {
      data : {
        field: {
          Asset       : self.state.Asset,
          Service     : self.state.Service,
          Description : self.state.Description,
        },
        AuthorizationToken : self.props.UserReducer.token,
      },
      self: self,
      onsuccess: self.onRequestSuccess,
      onfailed : self.onRequestFailed,
    }
  },
  RegisterReport(self, onsuccess, onfailed) {
    return {
      data: {
        field: {
          Asset       : self.state.Asset,
          Type        : self.state.Type,
          Description : self.state.Description,
        },
        AuthorizationToken : self.props.UserReducer.token,
      },
      self: self,
      onsuccess: self.onReportSuccess,
      onfailed : self.onReportFailed,
    }
  },
  Update: function(self, onsuccess, onfailed) {
   return {
       data : {
          field: {
            Asset          : self.state.asset,
            Service        : self.state.service,
            Description    : self.state.description,
            ScheduledStart : self.state.scheduledStart_UTC,
            ScheduledEnd   : self.state.scheduledEnd_UTC,
            IsRepeating    : self.state.isRepeating,
            RepeatPeriod   : self.state.repeatPeriod,
            RepeatType     : self.state.repeatType,
            IsReminder     : self.state.isReminder,
            NextScheduled  : self.state.nextScheduled_UTC,
          },
          Alias: self.state.alias,
          AuthorizationToken : self.props.UserReducer.token,
       },
       self : self,
       onsuccess : self.onUpdateSuccess,
       onfailed : self.onUpdateFailed,
   } 
  },
  StartWork: function(data, self, onsuccess, onfailed) {
    return {
        data : {    
          alias               : data.Alias,
          contractor          : data.Contractor,
          AuthorizationToken  : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onStartWorkSuccess,
        onfailed : self.onStartWorkFailed,
    }
  },
  QuickTest: function(alias, self, onsuccess, onfailed) {

    return {
        data : {    
          alias               : alias,
          AuthorizationToken  : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onQuickTestSuccess,
        onfailed : self.onQuickTestFailed,
    }
  },
  FinishWork: function(data, self, onsuccess, onfailed) {
    return {
        data : {    
          Alias: data.Alias,
          Data : data.Data,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onFinishWorkSuccess,
        onfailed : self.onFinishWorkFailed,
    }
  },
  RegisterReminder: function(work, index, self, onsuccess, onfailed) {
    return {
        data : {
          field: {
            Time   : self.state.tmpReminder[index].Time_UTC,
            Method : self.state.tmpReminder[index].Method,
            Email  : self.state.tmpReminder[index].Email,
            Mobile : self.state.tmpReminder[index].Mobile,
            Work   : work,
          },
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onRegisterReminderSuccess,
        onfailed : self.onRegisterReminderFailed,
    }
  },
  UpdateReminder: function(work, self, onsuccess, onfailed) {
   return {
     data : {
       field: {
         Time   : self.state.time_UTC,
         Method : self.state.method,
         Email  : self.state.email,
         Mobile : self.state.mobile,
       },
       Work   : work,
       AuthorizationToken : self.props.UserReducer.token,
     },
     self : self,
     onsuccess : self.onUpdateReminderSuccess,
     onfailed : self.onUpdateReminderFailed,
   } 
  },
  ReadReminderByWork: function(action, work, self, onsuccess, onfailed) {
    return {
      data : {
        query: work,
        AuthorizationToken : self.props.UserReducer.token,
      },
      action: action,
      self : self,
      onsuccess : self.onReadSuccess,
      onfailed : self.onReadFailed,
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/maintenance/helper/request.props.js